/**
 *
 * @author arman
 * @since 7/14/17
 *
 */
import React from 'react';
import BoxHeader from '../shared/box-header.component';

const styles = {
  root: {

  },
  nameDiv: {
    margin: '8px',
    height: '25px',
    fontWeight: 'bold',
    background: 'url(./images/icons/mission/view/patient.png) no-repeat',
  },
  nameText: {
    color: '#000000',
    fontSize: '15px',
    marginTop: '5px',
    marginLeft: '40px',
    display: 'inline-block'
  },
  details: {
    margin: '8px',
    height: '25px',
    color: '#000000',
    fontSize: '15px',
    marginTop: '8px',
    marginLeft: '5px'
  }
};

/**
 *
 * @param {object} mission
 * @param {string} className
 * @param {object} style
 * @constructor
 */
const PatientInfo = ({mission, className, style}) => (
  <div className={className} style={{...styles.root, ...style}}>
    <BoxHeader title='Patient Details'/>
    <div style={styles.nameDiv}>
      <div style={styles.nameText}>{mission.patient.name}</div>
    </div>
    <div style={styles.details}>
      <span>Patient Number: </span>
      <span>{mission.patient.patient_number}</span>
      </div>
    <div style={styles.details}>
      <span>Age: </span>
      <span>{mission.patient.ageInYear}</span> year(s),
      <span> {mission.patient.ageInMonth}</span> month(s)
    </div>
    <div style={styles.details}>
      <span>Gender: </span>
      <span>{mission.patient.gender}</span>
    </div>
    <div style={styles.details}>
      <span>Relation: </span>
      <span>{mission.patient.relation}</span>
    </div>
    <div style={styles.details}>
      <span>Address: </span>
      <span>{mission.location.address_line_1}</span>
    </div>
    <div style={styles.details}>
      <span>Long term condition: </span>
      <span>{mission.patient.long_term_conditions || 'N/A'}</span>
    </div>
    <div style={styles.details}>
      <span>Long term medication: </span>
      <span>{mission.patient.long_term_medications || 'N/A'}</span>
    </div>
    <div style={styles.details}>
      <span>Symptom: </span>
      <span>{mission.initial_conditions}</span>
    </div>
  </div>
);

export default PatientInfo;


// WEBPACK FOOTER //
// ./src/screens/mission-view/patient-info.component.js